function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var GET_EVENTTYPES_REQUEST = "GET_EVENTTYPES_REQUEST";
export var GET_EVENTTYPES_SUCCESS = "GET_EVENTTYPES_SUCCESS";
export var GET_EVENTTYPES_FAILURE = "GET_EVENTTYPES_FAILURE";
export var RESET_GET_EVENTTYPES = "RESET_GET_EVENTTYPES";

// Fetches all event types from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
var fetchEventTypes = function fetchEventTypes() {
  return _defineProperty({}, CALL_API, {
    types: [GET_EVENTTYPES_REQUEST, GET_EVENTTYPES_SUCCESS, GET_EVENTTYPES_FAILURE],
    endpoint: "eventTypes",
    init: {
      credentials: "same-origin"
    }
  });
};

// Fetches all event types unless it is cached.
// Relies on Redux Thunk middleware.
export var loadEventTypes = function loadEventTypes() {
  return function (dispatch, getState) {
    var eventTypes = getState().entities.eventTypes.byId;
    if (eventTypes && Object.keys(eventTypes).length > 0 && !forceUpdate) return null;
    return dispatch(fetchEventTypes());
  };
};